import { useMutation } from "@tanstack/react-query";
import {
  getUnreadSupportMessagesQueryData,
  setUnreadSupportMessagesQueryData,
} from "../hooks/useUnreadSupportMessages";

type Params = {
  decrementValue: number;
};

export const useDecrementUnreadMessagesMutation = () => {
  return useMutation<void, unknown, Params>({
    mutationFn: async ({ decrementValue }) => {
      const prevData = getUnreadSupportMessagesQueryData();
      if (prevData !== undefined) {
        setUnreadSupportMessagesQueryData(prevData - decrementValue);
      }
    },
  });
};
